"use client";

import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { useMemo } from "react";
import { readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import {
  type ProductOption_Fragment,
  ProductVariant_Fragment,
} from "#/graphql/shopify-storefront/fragments";
import { useProductVariantBySelectedOptionsQuery } from "#/hooks/shopify";
import { env } from "#/utilities/env";

export function SquarePlacement({
  handle,
  lang,
  optionsMasked,
}: {
  handle: string;
  lang: Navigator["language"];
  optionsMasked: FragmentOfShopifyStorefront<typeof ProductOption_Fragment>[];
}) {
  const data = useProductVariantBySelectedOptionsQuery({
    handle,
    lang,
    optionsMasked,
  });

  const variantBySelectedOptions = readFragmentShopifyStorefront(
    ProductVariant_Fragment,
    data?.product?.variantBySelectedOptionsMasked,
  );

  const placement = useMemo(
    () => ({
      amount: variantBySelectedOptions?.price.amount,
      currency: variantBySelectedOptions?.price.currencyCode,
      skus: variantBySelectedOptions?.sku,
      categories: data?.product?.productType,
    }),
    [data?.product?.productType, variantBySelectedOptions],
  );

  if (
    !lang ||
    !placement.currency ||
    !env.NEXT_PUBLIC_SQUARE_PLACEMENT_SUPPORTED_LOCALES.includes(
      placement.currency,
    )
  ) {
    return null;
  }

  return (
    <square-placement
      class="stroke-none"
      data-mpid={env.NEXT_PUBLIC_SQUARE_PLACEMENT_MPID}
      data-placement-id={env.NEXT_PUBLIC_SQUARE_PLACEMENT_ID}
      data-page-type="product"
      data-amount={placement.amount}
      data-currency={placement.currency}
      data-consumer-locale={lang}
      data-item-skus={placement.skus}
      data-item-categories={placement.categories}
      data-is-eligible="true"
    />
  );
}
